export const sampleCampaigns = [
    {
      id: 1,
      name: "Shreesant Tripathy",
      profession: "Influencer Marketing @ Freelancer- Self Employed",
      timeAgo: "1h ago",
      profileImage: "https://picsum.photos/100?random=1",
      linkedin: "https://linkedin.com/in/shreesant-tripathy",
      verified: true,
      phone: "+91 922 017 4144",
      whatsapp: "+44 7713709034",
      lookingFor: "Influencer Marketing Agencies",
      description: "Gen Z creators needed from Pune, Chennai, and Delhi for campaign",
      attributes: {
        brandName: "Not disclosed",
        campaignType: "City-based creator activation",
        platform: "Instagram",
        creatorsCategory: "Gen Z creators",
        followerRange: "Not specified",
        deliverables: "Not specified",
        budgetRange: "Not disclosed",
      },
      keyHighlights: {
        platform: "Instagram",
      },
      activity: {
        totalViews: 3,
        postedOn: "07 Nov 2025",
        expiresOn: "14 Nov 2025",
      },
    },
    {
      id: 2,
      name: "Utkarsh Shinde",
      profession: "Influencer Marketing @ Freelancer- Self Employed",
      timeAgo: "57m ago",
      profileImage: "https://picsum.photos/100?random=2",
      linkedin: "https://linkedin.com/in/utkarsh-shinde",
      verified: true,
      phone: "+91 922 017 4144",
      whatsapp: "+44 7713709034",
      lookingFor: "Influencer Marketing Agencies",
      description: "Hiring 2 male and 2 female shadows for Pune wedding event",
      attributes: {
        brandName: "Team Gleam Events",
        campaignType: "Event staffing - wedding reception",
        platform: "Offline (Event-based)",
        creatorsCategory: "Event assistants / on-ground staff (2 male, 2 female)",
        followerRange: "Not applicable",
        deliverables: "On-site event assistance (Shadow role)",
        budgetRange: "₹1,000/day (Food included, no stay)",
      },
      keyHighlights: {
        platform: "Offline Events",
      },
      activity: {
        totalViews: 12,
        postedOn: "06 Nov 2025",
        expiresOn: "13 Nov 2025",
      },
    },
    {
      id: 3,
      name: "Prashant Singh",
      profession: "Marketing Manager @ Tech Solutions",
      timeAgo: "2h ago",
      profileImage: "https://picsum.photos/100?random=3",
      linkedin: "https://linkedin.com/in/prashant-singh",
      verified: false,
      phone: "+91 922 017 4144",
      whatsapp: "+44 7713709034",
      lookingFor: "Content Creators",
      description: "Looking for 40 premium creators (English/Hindi) for a Movie & Series Review Campaign",
      attributes: {
        brandName: "Entertainment Hub",
        campaignType: "Content Creation - Review Campaign",
        platform: "YouTube & Instagram",
        creatorsCategory: "Movie & Series Reviewers (40 creators)",
        followerRange: "10K - 1M followers",
        deliverables: "1 Review Video + 2 Instagram Posts",
        budgetRange: "₹5,000 - ₹50,000 per creator",
      },
      keyHighlights: {
        platform: "YouTube & Instagram",
      },
      activity: {
        totalViews: 45,
        postedOn: "05 Nov 2025",
        expiresOn: "12 Nov 2025",
      },
    },
  ];

 export const followerRangeMap = {
    Nano: { instagram: '1k - 10k', youtube: '1k - 5k' },
    Micro: { instagram: '10k - 50k', youtube: '5k - 20k' },
    Macro: { instagram: '50k - 500k', youtube: '20k - 100k' },
    Mega: { instagram: '500k - 1M', youtube: '100k - 1M' },
    Celeb: { instagram: '1M+', youtube: '1M+' },
  };